import { css, keyframes } from 'styled-components';

const mapColorBlue = '#3b88e3';

const pulse919499 = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(145,148,153, .4);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(145,148,153, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(145,148,153, 0);
  }
`;

const pulse0044ff = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0,68,255, .4);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(0,68,255, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0,68,255, 0);
  }
`;

const pulse9013fe = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(144,19,254, .4);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(144,19,254, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(144,19,254, 0);
  }
`;

export const Markers = css`
  .map-hotel-marker {
    box-sizing: content-box;
    width: 10px;
    height: 10px;
    background-color: #919499;
    border: solid 2px #fff;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      z-index: 10 !important;
    }

    &.active {
      animation: ${pulse919499} 1.5s linear infinite;
    }

    &.inList {
      background-color: ${mapColorBlue};
    }

    &.filtered {
      background-color: transparent;
      border-color: ${mapColorBlue};
    }

    &.inList.active,
    &.filtered.active {
      animation: ${pulse0044ff} 1.5s linear infinite;
    }

    &.viewed {
      background-color: #9013fe;
      border: solid 2px #fff;
    }

    &.viewed.active {
      animation ${pulse9013fe} 1.5s linear infinite;
    }

    &-mobile {
      width: 15px;
      height: 15px;
    }
  }
`;
